import {
  FETCH_TOTAL_COUNT_REQUEST,
  FETCH_TOTAL_COUNT_SUCCESS,
  FETCH_TOTAL_COUNT_FAILURE,
  FETCH_TOTAL_REVENUE_REQUEST,
  FETCH_TOTAL_REVENUE_SUCCESS,
  FETCH_TOTAL_REVENUE_FAILURE,
  FETCH_DATA_BY_DATE_REQUEST,
  FETCH_DATA_BY_DATE_SUCCESS,
  FETCH_DATA_BY_DATE_FAILURE,
  FETCH_STATUS_DISTRIBUTION_REQUEST,
  FETCH_STATUS_DISTRIBUTION_SUCCESS,
  FETCH_STATUS_DISTRIBUTION_FAILURE,
  FETCH_TOP_DRIVERS_REQUEST,
  FETCH_TOP_DRIVERS_SUCCESS,
  FETCH_TOP_DRIVERS_FAILURE,
  FETCH_DISTRICT_REPORTS_REQUEST,
  FETCH_DISTRICT_REPORTS_SUCCESS,
  FETCH_DISTRICT_REPORTS_FAILURE,
  FETCH_TOP_USERS_BY_SPENDING_REQUEST,
  FETCH_TOP_USERS_BY_SPENDING_SUCCESS,
  FETCH_TOP_USERS_BY_SPENDING_FAILURE,
  FETCH_TOP_USERS_BY_PACKAGES_REQUEST,
  FETCH_TOP_USERS_BY_PACKAGES_SUCCESS,
  FETCH_TOP_USERS_BY_PACKAGES_FAILURE,
  FETCH_RECENT_TRANSACTIONS_REQUEST,
  FETCH_RECENT_TRANSACTIONS_SUCCESS,
  FETCH_RECENT_TRANSACTIONS_FAILURE,
} from '../actions/types';

const initialState = {
  counts: {
    users: 0,
    packages: 0,
    deliveries: 0,
    transactions: 0,
    drivers: 0,
    businesses: 0,
    vehicles: 0,
    reviews: 0,
    help_topics: 0,
    chats: 0,
    faqs: 0,
    notifications: 0,
  },
  totalRevenue: null,
  dataByDate: {
    users: [],
    packages: [],
    deliveries: [],
    transactions: [],
    drivers: [],
    businesses: [],
    vehicles: [],
    reviews: [],
    help_topics: [],
    chats: [],
    faqs: [],
    notifications: [],
  },
  statusDistribution: {
    users: {},
    packages: {},
    deliveries: {},
    transactions: {},
    drivers: {},
    businesses: {},
    vehicles: {},
    reviews: {},
    help_topics: {},
    chats: {},
    faqs: {},
    notifications: {},
  },
  topDrivers: [],
  districtReports: [],
  topUsersBySpending: [],
  topUsersByPackages: [],
  recentTransactions: [],
  loading: false,
  error: null,
  message: '',
};

// Reducer for handling actions
export default function analyticsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOTAL_COUNT_REQUEST:
    case FETCH_TOTAL_REVENUE_REQUEST:
    case FETCH_DATA_BY_DATE_REQUEST:
    case FETCH_STATUS_DISTRIBUTION_REQUEST:
    case FETCH_TOP_DRIVERS_REQUEST:
    case FETCH_DISTRICT_REPORTS_REQUEST:
    case FETCH_TOP_USERS_BY_SPENDING_REQUEST:
    case FETCH_TOP_USERS_BY_PACKAGES_REQUEST:
    case FETCH_RECENT_TRANSACTIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_TOTAL_COUNT_SUCCESS:
      // Destructure table and count from action.payload
      const { table, count } = action.payload;
      return {
        ...state,
        loading: false,
        counts: {
          ...state.counts,
          [table]: count || 0,  // Ensure count is either the value or 0 if it's null/undefined
        },
        message: 'Total count fetched successfully',
      };


    case FETCH_TOTAL_REVENUE_SUCCESS:
      return {
        ...state,
        loading: false,
        totalRevenue: action.payload.total,
        todaysRevenue: action.payload.today,
        message: 'Total revenue fetched successfully',
      };

    case FETCH_DATA_BY_DATE_SUCCESS:
      return {
        ...state,
        loading: false,
        dataByDate: {
          ...state.dataByDate,
          [action.payload.table]: action.payload.data,
        },
        message: 'Data by date fetched successfully',
      };


    case FETCH_STATUS_DISTRIBUTION_SUCCESS: {
      const { table: tableName, statusCounts } = action.payload;
      const statusDistribution = {};

      statusCounts.forEach(({ status, count }) => {
        const statusKey = status?.split('.')?.pop()?.toLowerCase();
        statusDistribution[statusKey] = count || 0;
      });

      return {
        ...state,
        loading: false,
        statusDistribution: {
          ...state.statusDistribution,
          [tableName]: statusDistribution,
        },
        message: `${tableName} status distribution fetched successfully`,
      };
    }



    case FETCH_TOP_DRIVERS_SUCCESS:
      return {
        ...state,
        loading: false,
        topDrivers: action.payload,
        message: 'Top drivers fetched successfully',
      };

    case FETCH_DISTRICT_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        districtReports: action.payload,
        message: 'District reports fetched successfully',
      };

    case FETCH_TOP_USERS_BY_SPENDING_SUCCESS:
      return {
        ...state,
        loading: false,
        topUsersBySpending: action.payload,
        message: 'Top users by spending fetched successfully',
      };

    case FETCH_TOP_USERS_BY_PACKAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        topUsersByPackages: action.payload,
        message: 'Top users by packages fetched successfully',
      };

    case FETCH_RECENT_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        recentTransactions: action.payload, 
        message: 'Recent transactions fetched successfully',
      };

    case FETCH_TOTAL_COUNT_FAILURE:
    case FETCH_TOTAL_REVENUE_FAILURE:
    case FETCH_DATA_BY_DATE_FAILURE:
    case FETCH_STATUS_DISTRIBUTION_FAILURE:
    case FETCH_TOP_DRIVERS_FAILURE:
    case FETCH_DISTRICT_REPORTS_FAILURE:
    case FETCH_TOP_USERS_BY_SPENDING_FAILURE:
    case FETCH_TOP_USERS_BY_PACKAGES_FAILURE:
    case FETCH_RECENT_TRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
